import { createSlice, configureStore, PayloadAction } from '@reduxjs/toolkit';

export type Lang = 'en' | 'id';

export const LANG_STORAGE_KEY = 'lang';

interface AuthState {
    isMobile: boolean | null; 
    lang: Lang;
}

// Saved choice wins; otherwise follow the browser language (Indonesian browsers get "id").
const detectInitialLang = (): Lang => {
  try {
    const saved = window.localStorage.getItem(LANG_STORAGE_KEY);
    if (saved === 'en' || saved === 'id') return saved;
  } catch {
    // localStorage can be blocked (private mode); fall through to detection
  }
  return navigator.language?.toLowerCase().startsWith('id') ? 'id' : 'en';
};

const initialState: AuthState = {
    isMobile: null,
    lang: detectInitialLang(),
};
  

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setIsMobile(state: AuthState, action: PayloadAction<boolean>) {
      state.isMobile = action.payload;
    },
    setLang(state: AuthState, action: PayloadAction<Lang>) {
      state.lang = action.payload;
    },
  },
});

export const { setIsMobile, setLang } = authSlice.actions;

export const store = configureStore({
    reducer: {
      auth: authSlice.reducer,
    },
});
  
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
